import * as React from 'react';
import * as styles from './styles.css';

export interface IUnitProps {
  text: string;
}
export const Unit: React.FC<IUnitProps> = ({ text }) => {
  return <span className={styles['unit']}>{text}</span>;
};

Unit.displayName = 'Unit';
